import { View } from 'react-native'
import { styled } from '~/core/styled'

export const RightButton = styled(View, theme => {
  return {
    base: {
      alignSelf: 'flex-end',
      paddingLeft: theme.paddingInsetTwopulse,
    },
  }
})
